import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { Input } from '@1trading/react/components/ui/input';
import { RadioGroup, RadioGroupItem, RadioGroupItemCard } from '@1trading/react/components/ui/radio-group';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { BINARY_ANSWERS } from '@/constants/answers';
import type { InstitutionComplianceTrainingOrDefaults } from '@/features/institution/compliance-training/schema';

const InstitutionComplianceTrainingFieldsetProgramme = () => {
  const form = useFormContext<InstitutionComplianceTrainingOrDefaults>();
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <FormField
        control={form.control}
        name="complianceHeadcount"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.complianceTraining.programme.complianceHeadcount')}*</FormLabel>
            <FormControl>
              <Input
                {...field}
                className="no-spinner"
                inputMode="numeric"
                placeholder={t('institutionDetails.complianceTraining.placeholders.complianceHeadcount')}
                type="number"
                value={field.value ?? ''}
                onChange={(event) => field.onChange(event.target.value === '' ? undefined : Number(event.target.value))}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="abcPolicies"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.complianceTraining.programme.abcPolicies')}*</FormLabel>
            <FormControl>
              <RadioGroup defaultValue={field.value} variant="cards" aria-label={t('institutionDetails.complianceTraining.programme.abcPolicies')} onValueChange={field.onChange}>
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="privacyPolicyCompliant"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('institutionDetails.complianceTraining.programme.privacyPolicyCompliant')}*</FormLabel>
            <FormControl>
              <RadioGroup
                defaultValue={field.value}
                variant="cards"
                aria-label={t('institutionDetails.complianceTraining.programme.privacyPolicyCompliant')}
                onValueChange={field.onChange}
              >
                {BINARY_ANSWERS.map((answer) => (
                  <FormItem key={answer}>
                    <RadioGroupItemCard variant="outline">
                      <FormControl>
                        <RadioGroupItem value={answer} />
                      </FormControl>
                      <FormLabel contained>{t(`fundamentals.${answer.toLowerCase()}`)}</FormLabel>
                    </RadioGroupItemCard>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
InstitutionComplianceTrainingFieldsetProgramme.displayName = 'InstitutionComplianceTrainingFieldsetProgramme';

export { InstitutionComplianceTrainingFieldsetProgramme };
